import { render, staticRenderFns } from "./PageSettingsTags.vue?vue&type=template&id=0f32a882&"
import script from "./PageSettingsTags.vue?vue&type=script&lang=ts&"
export * from "./PageSettingsTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports